import React, { useMemo } from "react";
import TemplateEditorContent from "../TemplateEditorContent/TemplateEditorContent";

const useTabsData = ({
  allowImages,
  allowVideos,
  template,
  onChange,
  showVerticalImage,
  isSnapchatChannel,
  showTikTokVideoTemplate,
  inputProps,
  closeTemplateEditor,
  t
}) => {
  return useMemo(() => {
    const tabsData = [];

    if (allowImages) {
      tabsData.push({
        key: "ImageTemplates",
        tab: t("Image Templates"),
        panel: (
          <TemplateEditorContent
            template={template}
            onChange={onChange}
            showVerticalImage={showVerticalImage}
            inputProps={inputProps}
            closeTemplateEditor={closeTemplateEditor}
            templateTypeSelected="image"
            showTikTokVideoTemplate={showTikTokVideoTemplate}
            isSnapchatChannel={isSnapchatChannel}
          />
        )
      });
    }

    if (allowVideos) {
      tabsData.push({
        key: "VideoTemplates",
        tab: t("Video Templates"),
        panel: (
          <TemplateEditorContent
            template={template}
            onChange={onChange}
            showVerticalImage={showVerticalImage}
            inputProps={inputProps}
            closeTemplateEditor={closeTemplateEditor}
            templateTypeSelected="video"
            showTikTokVideoTemplate={showTikTokVideoTemplate}
            isSnapchatChannel={isSnapchatChannel}
          />
        )
      });
    }

    return tabsData;
  }, [
    allowImages,
    allowVideos,
    template,
    onChange,
    showVerticalImage,
    inputProps,
    closeTemplateEditor,
    isSnapchatChannel,
    showTikTokVideoTemplate,
    t
  ]);
};

export default useTabsData;
